module.exports = __webpack_public_path__ + "static/media/banner-I-REC.7cd5e822.webp";